import { useTranslation } from "react-i18next";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { Flex } from "antd";

import { resolveAdminSettingsRolesAndPermissionsTitle } from "@av/apps/common-apps/platform/services/admin-settings/admin-settings";
import { Button } from "@av/components/atoms/Button";
import { Typography } from "@av/components/atoms/typography/Typography";
import { ForbiddenErrorPage } from "@av/components/templates/layouts/errors/types/ForbiddenErrorPage";

import type { PlatformAppEntry } from "../../services/apps/types";

type AdminSettingsSectionProps = {
  onSectionChange: (section: string) => void;
  selectedSection: string;
  apps: Array<Pick<PlatformAppEntry, "path" | "adminSettings">>;
};

export function AdminSettingsSection(props: AdminSettingsSectionProps) {
  const { onSectionChange, selectedSection, apps } = props;
  const { t } = useTranslation();
  const isAdminSettingsEnabled = useBooleanFlagValue("admin_settings", false);
  const selectedApp = apps.find((app) => app.path === selectedSection);
  const RolesAndPermissionsContent = selectedApp?.adminSettings?.RolesAndPermissions;
  const handleBackToProducts = () => {
    onSectionChange("products");
  };

  if (!isAdminSettingsEnabled) {
    return <ForbiddenErrorPage />;
  }

  return (
    <Flex vertical gap="middle" flex="1 0 0">
      <Flex align="center" gap="middle">
        <Button
          aria-label={t("platform.adminSettings.backToProducts")}
          icon={<ArrowLeftOutlined />}
          testIdPrefix="admin-settings-hr-back"
          type="text"
          onClick={handleBackToProducts}
        />
        <Typography.Text
          testIdPrefix={`admin-settings-${selectedSection}-roles-and-permissions`}
          strong
        >
          {resolveAdminSettingsRolesAndPermissionsTitle(t, selectedSection)}
        </Typography.Text>
      </Flex>
      {RolesAndPermissionsContent && (
        <RolesAndPermissionsContent
          selectedSection={selectedSection}
          onSectionChange={onSectionChange}
        />
      )}
    </Flex>
  );
}
